module.exports = __webpack_public_path__ + "img/shuffle.c5ecaa73.svg";